import { render, staticRenderFns } from "./UpdateModalStatus.vue?vue&type=template&id=33cdeea4&"
import script from "./UpdateModalStatus.vue?vue&type=script&lang=js&"
export * from "./UpdateModalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports